import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.use(Router)

const router = new Router({
  mode: "history",
  // base: process.env.BASE_URL,
  routes: [
    //重定向
    {
      path: "/",
      redirect: "/index",
      meta: {
        title:'博仕机电'
      }
    },
    //首页
    {
      path: "/index",
      name: "index",
      component: () => import('@/views/index/index.vue'),
      meta: {
        title:'博仕机电'
      }
    },
    //关于博仕
    {
      path: "/aboutBuchtech",
      name: "aboutBuchtech",
      component: () => import('@/views/aboutBuchtech/aboutBuchtech.vue'),
      meta: {
        title:'关于博仕'
      }
    },
    // 产品详情页
    {
      path: "/productDetails",
      name: "productDetails",
      component: () => import('@/views/product/productDetails.vue'),
      meta: {
        title:'核心产品'
      }
    },
    // 产品分类列表
    {
      path: "/productCatalogList",
      name: "productCatalogList",
      component: () => import('@/views/product/productCatalogList.vue'),
      meta: {
        title:'核心产品'
      }
    },
    // 资讯列表
    {
      path: "/articleList",
      name: "articleList",
      component: () => import('@/views/article/articleList.vue'),
      meta: {
        title:'企业动态'
      }
    },
    // 资讯详情
    {
      path: "/articleDetails",
      name: "articleDetails",
      component: () => import('@/views/article/articleDetails.vue'),
      meta: {
        title:'企业动态'
      }
    },
    {
      path: '*',
      redirect: '/',
      meta: {
        title:'首页'
      }
    },
  ]
})

//路由开始跳转进度条结束
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if(to.query.catalogId&&to.query.productId){

  }else{
    window.scrollTo(0,0);
  }
  next()
})

//路由跳转完毕进度条消失
router.afterEach(() => {
  NProgress.done()
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js